/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useAuth } from "cms/auth/hooks/use-auth";
import { isValidGuid } from "utils/empty-exists";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { RichTextPreview } from "cms/rich-text/simplicity-composer-tiptap";
import { useEffect, useState } from "react";
import { TestimonialImage } from "./image";

const TestimonialItemDisplay = (props) => {
    const { item } = props;
    const image_guid = item?.image;
    const name = item?.name;
    const role = item?.role;
    const company = item?.company;
    const quote = item?.quote;

    const { token } = useAuth();
    const [image, setImage] = useState();

    useEffect(() => {
        const fetch = async () => {
            console.log("fetching..", image, image_guid);
            if (!image) {
                if (image_guid && isValidGuid(image_guid)) {
                    const img = await SimpliCityAdminSDK.images.findOne(token, image_guid);
                    setImage(img);
                }
            }
        };
        fetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, image_guid]);

    return (
        <div className="simplicity-testimonial-item-display">
            <div className="quote">{quote && <RichTextPreview richtext={quote} />}</div>
            {image && (
                <div className="simplicity-testimonial-image">
                    <TestimonialImage image={image} />
                </div>
            )}
            <div className="testimonial-info">
                <div className="name">{name}</div>
                <div className="role">{role}</div>
                <div className="company">{company}</div>
            </div>
        </div>
    );
};

export { TestimonialItemDisplay };
